<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
        :disabled="loading"
        :elevation="hover ? 16 : 2"
        :class="[`degree-${session.caseSourceId}`,{ 'on-hover': hover }]"
      >
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <div class="d-flex font-weight-black header-text">
          <div
            class="pa-3 ml-auto text-c-dark cursor-pointer"
            @click="$emit('session-card-click',session)"
          >
            <v-icon
              large
              color="var(--app-primary-color)"
              class="ml-3"
            >
              mdi-account-group
            </v-icon>
            <span class="case-update-card-header"> {{ session.sessionType }}</span>
          </div>
          <div
            class="mt-2"
            :class="{'px-3 ': !isRemoteArgumentOrCaseManagementELitigation }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="text-c-lite mr-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ toHijriDate(session.sessionDate) }} </span>
                  <span
                    v-if="session.appointmentStartDate"
                    class="d-block text-center"
                  >{{ getTime12Format(session.appointmentStartDate) }}{{ isAm(session.appointmentStartDate)? local.calendar.amShort: local.calendar.pmShort }} </span>
                </span>
              </template>
              <span> {{ getTimeSlot(session.appointmentStartDate,session.appointmentEndDate) }} {{ isAm(session.appointmentStartDate)? local.calendar.am: local.calendar.pm }}</span>
            </v-tooltip>
          </div>
          <div
            v-if="isRemoteArgumentOrCaseManagementELitigation"
            class="mt-2"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-icon
                  large
                  v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item v-if="false && session.sessionStatusId == 1">
                  <v-list-item-title>
                    <router-link :to="`/lawsuit-requests/${session.objectKey}`">
                      <naj-button
                        text
                        type="button"
                        size="small"
                      >
                        {{ local.home.upcomingSessions.changeSessionRequest }}
                      </naj-button>
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="false && session.sessionStatusId == 3">
                  <v-list-item-title>
                    <router-link :to="`/lawsuit-requests/${session.objectKey}`">
                      <naj-button
                        text
                        type="button"
                        size="small"
                      >
                        {{ local.home.upcomingSessions.requestApproveAttendanceRequest }}
                      </naj-button>
                    </router-link>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="isRemoteArgumentOrCaseManagementELitigation">
                  <v-list-item-title>
                    <router-link :to="`/written-pleading?caseObjectKey=${caseObjectKey}&courtId=${courtId}&sessionTypeId=${session.sessionTypeId}&sessionObjectKey=${session.objectKey}&isPega=${isPega}`">
                      <naj-button
                        text
                        type="button"
                        size="small"
                      >
                        {{ local.home.upcomingSessions.writtenPleading }}
                      </naj-button>
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div>
          <div
            class="cursor-pointer"
            @click="$emit('session-card-click',session)"
          >
            <div
              v-if="session.sessionStatus"
              class="row px-2 header-text"
            >
              <div class="py-1  text-c-green col-4">
                {{ local.caseFile.cards.session.statusDisplayName }}
              </div>
              <div
                class="py-1  text-info-value col-8"
                :title="session.sessionStatus"
              >
                {{ session.sessionStatus }}
              </div>
            </div>

            <div
              v-if="session.court"
              class="row px-2 header-text"
            >
              <div class="py-1  text-c-green col-4">
                {{ local.home.tabCommon.courtName }}
              </div>
              <div
                class="py-1  text-info-value col-8"
                :title="session.court"
              >
                {{ session.court }}
              </div>
            </div>

            <div
              v-if="session.subCircle"
              class="row px-2 header-text"
            >
              <div class="py-1  text-c-green col-4">
                {{ local.home.tabCommon.subCircleName }}
              </div>
              <div
                class="py-1  text-info-value col-8"
                :title="session.subCircle"
              >
                {{ session.subCircle }}
              </div>
            </div>
          </div>
          <div class="row px-2 header-text">
            <div class="py-1  text-c-green col-4">
              {{ local.caseFile.cards.session.codeDisplayName }}
            </div>
            <div class="py-1 text-info-value col-8">
              <template v-if="session.isVideoConference">
                <template>
                  <span>
                    {{ local.home.upcomingSessions.remoteSession }}
                  </span>
                </template>
                <v-tooltip
                  v-if="isAllowedShowAttendanceRegister && (userHasSessionAttendanceRecord || isFirmHasSessionAttendanceRecord)"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="var(--app-primary-color)"
                      class="copy-icon ml-1"
                      v-bind="attrs"
                      left
                      v-on="on"
                      @click="copyURL"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span> {{ local.home.upcomingSessions.copyLink }}</span>
                </v-tooltip>
              </template>
              <template v-else-if="isRemoteArgumentOrCaseManagementELitigation || session.sessionTypeId == sessionTypes.expert">
                <span>{{ local.caseFile.cards.sessionTypes.chatSession }}</span>
              </template>
              <template v-else>
                <v-icon
                  color="var(--app-primary-color)"
                  class="copy-icon mx-0"
                  left
                >
                  mdi-map-marker
                </v-icon>
                <span>{{ local.caseFile.cards.sessionTypes.attendance }}</span>
                <span> {{ local.home.upcomingSessions.courtLocation }} </span>
              </template>
            </div>
          </div>
        </div>
        <v-divider class="mt-5 mb-0"></v-divider>

        <div class="d-flex justify-content-end font-weight-black text-c-green">
          <div
            v-if="isRemoteArgumentOrCaseManagementELitigation || session.sessionTypeId == sessionTypes.expert"
            class="px-1 pa-3 ml-auto"
          >
            <router-link :to="`/written-pleading?caseObjectKey=${caseObjectKey}&courtId=${courtId}&sessionTypeId=${session.sessionTypeId}&sessionObjectKey=${session.objectKey}&isPega=${isPega}`">
              <naj-button
                text
                type="button"
                size="small"
                outlined
                class="pleading-action"
                color="red"
              >
                {{ isRemoteArgumentOrCaseManagementELitigation? local.home.upcomingSessions.writtenPleading: local.home.upcomingSessions.enterSession }}
              </naj-button>
            </router-link>
          </div>
          <div
            v-if="(isAllowedShowAttendanceRegister && !userHasSessionAttendanceRecord && !isFirmHasSessionAttendanceRecord) && !showEnterSessionBtn"
            class="d-flex align-items-center"
          >
            <naj-button
              type="button"
              size="small"
              @click="confirmAttendanceRegister(session.objectKey)"
            >
              {{ local.home.upcomingSessions.attendanceRegister }}
            </naj-button>
          </div>
          <div
            v-if="(isAllowedShowAttendanceRegister && (userHasSessionAttendanceRecord || isFirmHasSessionAttendanceRecord)) || showEnterSessionBtn"
            class="d-flex align-items-center"
          >
            <naj-button
              type="button"
              size="small"
              @click="openVideoConference(session.objectKey)"
            >
              {{ local.home.upcomingSessions.enterSession }}
            </naj-button>
          </div>
          <div
            v-if="session.userCanAttestOnDabt"
            class="d-flex align-items-center"
          >
            <naj-button
              class="cursor-pointer"
              @click="$emit('attest-session', session)"
            >
              {{ local.caseFile.cards.session.attest }}
            </naj-button>
          </div>
          <div
            v-else-if="!session.userCanAttestOnDabt && session.sessionStatusId == sessionStatus.finished"
            class="d-flex align-items-center"
          >
            <naj-button
              class="cursor-pointer"
              @click="$emit('session-card-click',session)"
            >
              {{ local.caseFile.cards.session.show }}
            </naj-button>
          </div>
          <div
            v-if="session.caseSourceId"
            class="px-2 pa-3"
          >
            <span :class="`degree-text-${session.caseSourceId}`"> {{ caseDegrees[session.caseSourceId] }}</span>
          </div>
        </div>
      </v-card>
    </v-hover>
    <naj-confirmation
      :show-modal="showAttendanceRegisterValidation"
      color="error"
      :title="local.home.upcomingSessions.attendanceRegister"
      :message="attendanceRegisterValidationMessage"
      @cancel="showAttendanceRegisterValidation = false"
    ></naj-confirmation>

    <naj-confirmation
      :show-modal="showAttendanceRegister"
      :max-width="771"
      :title="local.home.upcomingSessions.attendanceRegister"
      :show-close-btn="true"
      @cancel="() => {
        showAttendanceRegister = false
        pledged = false;
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <div>
              <p class="attendanceRegister-title-header">
                {{ local.home.upcomingSessions.attendanceRegisterPart1 }}
              </p>
              <h6 class="attendanceRegister-title-condition">
                {{ local.home.upcomingSessions.termsAndConditions }}
              </h6>
            </div>
            <div class="details__documentList">
              <div
                class="details__documentItem"
                style="width:100%"
              >
                {{ local.home.upcomingSessions.attendanceRegisterFirstConditions }}
              </div>
              <div
                class="details__documentItem"
                style="width:100%"
              >
                {{ local.home.upcomingSessions.attendanceRegisterSecondConditions }}
              </div>
            </div>
            <p class="text-condition">
              {{ local.home.upcomingSessions.attendanceRegisterPart2 }}
            </p>
          </v-col>
        </v-row>
      </template>
      <template slot="actions">
        <naj-button
          :disabled="!pledged"
          @click="registerToSession(session.objectKey)"
        >
          {{ local.home.upcomingSessions.attendanceRegister }}
        </naj-button>
      </template>
      <template slot="footer-content">
        <naj-input
          :type-id="formFieldType.checkbox"
          :value.sync="pledged"
          :label="local.home.upcomingSessions.agreeOnTermsAndConditions"
        ></naj-input>
      </template>
    </naj-confirmation>

    <naj-confirmation
      :show-modal="showRedirectToSessionModal"
      :max-width="750"
      :is-persistent="true"
      :title="local.home.upcomingSessions.goToSession"
      :show-close-btn="false"
      @cancel="() => {
        showRedirectToSessionModal = false
        redirectToSessionLink = null;
      }"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <naj-alert type="success">
              <template slot="content">
                {{ local.home.upcomingSessions.toRedirectToSessionLink }}
                <a
                  :href="redirectToSessionLink"
                  target="_blank"
                  class="redirect-session-link"
                >
                  {{ local.common.clickHere }}
                </a>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>
  </div>
</template>

<script>
import { toHijriDate, getTimePart, getTime12Format, isAm, getTimeSlot, getHoursDifference } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions, mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import { sessionTypes, caseDegrees, sessionStatus, userType } from '@/helpers/enum';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'SessionCard',
  components: {},
  props: {
    session: {
      type: Object,
      required: true,
    },
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
    courtId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      sessionTypes,
      caseDegrees,
      sessionStatus,
      userType,
      showAttendanceRegisterValidation: false,
      attendanceRegisterValidationMessage: '',
      showAttendanceRegister: false,
      showEnterSessionBtn: false,
      pledged: false,
      loading: false,
      showRedirectToSessionModal: false,
      redirectToSessionLink: null,
      isUserAttendSession: false,
      componentLoaded: false,
      userCanAttest: false,
      showAttendSession: false
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),

    isRemoteArgumentOrCaseManagementELitigation() {
      return this.session.sessionTypeId == sessionTypes.remoteArgument || this.session.sessionTypeId == sessionTypes.caseManagementELitigation;
    },
      isAllowedShowAttendanceRegister() {
          return this.showAttendSession;
      //return this.userInfo && ((this.session.statusId == sessionStatus.new || this.session.statusId == sessionStatus.inProgress || this.session.statusId == sessionStatus.newHearing || this.session.statusId == sessionStatus.inProgressHearing)
      //  && (this.session.sessionTypeId == sessionTypes.pleadingSession || this.session.sessionTypeId == sessionTypes.judgmentHearingSession
      //    || this.session.sessionTypeId == sessionTypes.firstHearingSession || this.session.sessionTypeId == sessionTypes.secretWitnessSession));
    },
    userHasSessionAttendanceRecord() {
      return this.session
        && this.userInfo && this.userInfo.userType != this.userType.najizOrganization
        && (this.session.sessionAttendences || []).some(sa => sa.socialId == this.userInfo.socialId && sa.identityType == this.userInfo.socialIdType);
    },

    isFirmHasSessionAttendanceRecord() {
      return this.session
        && this.userInfo && this.userInfo.userType == this.userType.najizOrganization
        && (this.session.sessionAttendences || []).some(sa => sa.socialId == this.userInfo.impersonatedBySocialId);
    },
        },
  mounted() {
      this.loading = true;
      var sessionObjectKey = this.session.objectKey;
      this.UserCanAttendSession(sessionObjectKey).then((res) => {
          this.showAttendSession = res.data;
      }).catch(() => {
          this.showAttendSession = false;
      }).finally(() => (this.loading = false));
            },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapCasesActions([
      'validationAttendanceRegister',
      'getVideoConference',
      'addAttendanceRegisterToSession',
      'CheckUserCanAttest',
      'UserCanAttendSession'
    ]),
    toHijriDate,
    isAm,
    getTimeSlot,
    getTime12Format,
    getTimePart,
    getHoursDifference,
    async copyURL() {
      if (this.session.videoConferenceUrl) {
        await navigator.clipboard.writeText(this.session.videoConferenceUrl);
        this.toaster.success(this.local.home.upcomingSessions.copied);
      }
    },
    confirmAttendanceRegister(sessionObjectKey) {
      this.loading = true;
      this.validationAttendanceRegister(sessionObjectKey).then(() => {
        this.showAttendanceRegister = true;
      }).catch(() => {

      }).finally(() => (this.loading = false));
    },
      registerToSession(sessionObjectKey) {
        this.loading = true;
        this.addAttendanceRegisterToSession(sessionObjectKey).then(() => {
        this.showAttendanceRegister = false;
        this.pledged = false;
        this.toaster.success(this.local.home.upcomingSessions.registrationSuccessful);
        if (this.session.videoConferenceUrl) {
          this.openVideoConference(sessionObjectKey);
        }
      }).catch(() => {
        this.showAttendanceRegister = false;
      }).finally(() => (this.loading = false));
      },
    openVideoConference(sessionObjectKey) {
      this.loading = true;
      this.getVideoConference(sessionObjectKey)
        .then((res) => {
          this.redirectToSessionLink = res.data;
          this.showEnterSessionBtn = true;
          this.showRedirectToSessionModal = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};

</script>

<style lang="scss" scoped>
.copy-icon {
  font-size: 20px;
}
.videoConferenceUrl {
  color: var(--app-primary-color);
  cursor: pointer;
}

.session-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

.text-c-green {
  color: var(--app-primary-color);
}

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
}

.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}

.pleading-action {
  &::v-deep .theme--light.v-btn.v-btn--outlined.v-btn--text {
    border-color: red;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.attendanceRegister-title-header {
  color: #707070;
  font-size: 16px;
}
.attendanceRegister-title-condition {
  color: var(--app-lighter-primary-color);
  font-size: 18px;
  margin: 12px;
  text-align: right;
}
.text-condition {
  color: var(--app-dark-primary-color);
  font-size: 16px;
}

.redirect-session-link {
  color: #144afa;
  display: inline;
}

    .degree-1 {
        border: 2px solid #97dfdf;

        .degree-text-1 {
            color: #97dfdf;
            font-size: 16px;
            font-weight: bolder;
        }
    }

    .degree-2 {
        border: 2px solid var(--app-primary-color);

        .degree-text-2 {
            color: var(--app-primary-color);
            font-size: 16px;
            font-weight: bolder;
        }
    }

    .degree-3 {
        border: 2px solid var(--app-dark-primary-color);

        .degree-text-3 {
            color: var(--app-dark-primary-color);
            font-size: 16px;
            font-weight: bolder;
        }
        }
</style>
